import {FETCH_BUDGET_COMPONENTS, RECEIVE_BUDGET_COMPONENTS, FAILED_BUDGET_COMPONENTS} from '../../actions/budgeting/aBudget-YearlyComponent'

const defaultComponentList = {
    data: []
}

export function fetchBudgetYearlyComponent(state = defaultComponentList, action){
    switch(action.type){
        case FETCH_BUDGET_COMPONENTS:
            return({data: [], inProgress: true})
        case RECEIVE_BUDGET_COMPONENTS:
            //console.log(action.payload)
            return Object.assign({}, state, {data: action.payload, inProgress: false})
        case FAILED_BUDGET_COMPONENTS:
            return({data: [], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/budgeting/redBudgeting-YearlyComponent.jsx